<template>
 <h1>import</h1>
</template>

<script>

export default {
	name: 'import'
}

</script>
